import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-fixed tw-inset-0 tw-z-loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "tw-absolute tw-inset-0 tw-bg-mainbg1 tw-opacity-50",
  "tw-z-loading": ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tw-absolute tw-inset-0 tw-z-loading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center tw-items-center tw-h-screen tw-text-primary tw-text-2xl" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "tw-text-center" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Loading"),
      /*#__PURE__*/_createElementVNode("div", { class: "tw-border-r-4 tw-border-t-4 tw-border-solid tw-border-primary tw-rounded-full tw-w-10 tw-h-10 tw-m-auto tw-animate-spin" })
    ])
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : _createCommentVNode("", true)
}